import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: any) => ({
  container: {
    display: "flex",
    gap: "20px",
    marginTop: "1.5rem",
  },
  freeTrialContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
  },
  videoHeader: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1.5rem",
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    flex: 1,
  },
  packageName: {
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: "18px",
  },
  price: {
    fontWeight: "bold",
    fontSize: "25px",
  },
  renewalText: {
    color: "gray",
    fontSize: "15px",
  },
  btnContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "flex-end",
    gap: "10px",
    flex: 1,
  },
  btn: {
    textTransform: "capitalize",
    backgroundColor: "#4d1277",
    color: "white",
    border: "1px solid #4d1277",
    borderRadius: "8px",
    "&:hover": {
      color: "white",
      backgroundColor: "#4d1277",
      opacity: "0.8",
    },
  },
  btnCancel: {
    textTransform: "capitalize",
    backgroundColor: "white",
    color: "black",
    border: "1px solid black",
    borderRadius: "8px",
    "&:hover": {
      opacity: "0.8",
    },
  },
  cardDetailContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginTop: "8px",
  },
  cardDetail: {
    display: "flex",
    justifyContent: "space-between",
  },
  billingText: {
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: "18px",
    marginBottom: "5px",
    marginTop: "5rem",
  },
  updateText: {
    color: "gray",
    cursor: "pointer",
    width: "fit-content",
    borderBottom: "1px solid gray",
  },
  crossIcon: {
    backgroundColor: "white",
    borderRadius: "50%",
    border: "3px solid #4d1277",
    color: "#4d1277",
    fontSize: "35px",
  },
  // plans header
  planHeadBox: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    // zIndex: 1,
    //
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginBottom: "20px",
  },
  planHeadBoxHeading: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  planHeadBoxSubHeading: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
  },
  // freetrial container
  freeTrialBox: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#EAE9E9",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  freeTrialHeadText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  freeTrialExpiryText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
  },
  freeTrialMessageText: {
    marginTop: "5px",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    color: "#272525",
  },
  freeTrialUpgradePlanBtn: {
    marginTop: "5px",
    borderRadius: "6px",
    textTransform: "capitalize",
    alignSelf: "flex-start",
    //
    backgroundColor: "#4d1277",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "#fff",
    },
    maxWidth: "183px",
    width: "100%",
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
  },
  freeTrialCountText: {
    marginTop: "25px",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
  },
  //
  subscriptionDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    // height: "calc(100vh - 160px)",
    overflowY: "scroll",
    //
    height: "calc(100vh - 180px)",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("xmd")]: {
      height: "calc(100vh - 230px)",
    },
  },
  paymentErrorBox: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#FFF8F8",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginBottom: "20px",
  },
  paymentErrorMessage: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
    marginTop: "5px",
  },
  //
  cardDetailsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    //
    flexWrap: "wrap",
    gap: "1rem",
  },
  cardDetailsInnerBox: {
    minWidth: "250px",
    flex: "1 1 300px",
  },
  cardDetailsData: {
    flex: "2 1 400px",
    //
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    margin: "auto",
    gap: "1.5rem",
  },
  addPaymentMethodBtn: {
    borderRadius: "6px",
    background: "#4D1277",
    color: "white",
    "&:hover": {
      background: "#4D1277",
      color: "white",
    },
    border: "none",
    fontSize: 16,
    fontWeight: 400,
    padding: "4px 10px",
    marginBottom: "10px",
    fontFamily: "400",
    textTransform: "capitalize",
  },
  addPaymentMethodIcon: {
    color: "white",
    width: "20px",
    height: "20px",
    marginRight: 1,
  },
  rotateIcon: {
    transition: "transform 0.3s ease",
  },
  rotatedLeft: {
    transform: "rotate(0deg)", // Rotate the icon by 45 degrees
  },
  rotatedRight: {
    transform: "rotate(45deg)", // Rotate the icon by 45 degrees
  },
  deleteSubscriptionBtn: {
    marginTop: "30px",
    backgroundColor: "#4d1277",
    color: "white",
    borderRadius: "5px",
    paddingRight: "36px",
    paddingLeft: "36px",
    width: "fit-content",
    textTransform: "capitalize",
    alignSelf: "flex-end",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
    },
  },
  paymentCardDetailsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "10px",
    padding: "12px",
    backgroundColor: "#EAE9E9",
    width: "100%",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  },
  paymentCardLeftDetails: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  paymentCardImage: {
    border: "1px solid #64748B",
    borderRadius: "12px",
  },
  paymentCardDetail1: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#000000",
  },
  paymentCardDetail2: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
  },
  paymentCardRightControls: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  defaultPaymentMethod: {
    color: "#000",
    backgroundColor: "#999",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    borderRadius: "5px",
    textTransform: "capitalize",
    cursor: "default",
  },
  expiredPaymentMethod: {
    color: "#FF1B1B",
    backgroundColor: "#FF1B1B3D",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    borderRadius: "5px",
    textTransform: "capitalize",
    cursor: "default",
  },
  setAsDefaultMehthod: {
    textTransform: "capitalize",
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    color: "#4d1e8f",
    backgroundColor: "#dbd0e4",
    padding: "5px",
    "&:hover": {
      backgroundColor: "#dbd0e4",
      padding: "5px",
    },
    cursor: "pointer",
  },
  // deleteConfirmationDialog
  deleteDialogTitle: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    textAlign: "center",
    color: "#272525",
    lineHeight: "normal",
  },
  deleteDialogText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999",
  },
  deleteDialogBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    marginTop: "15px",
    width: "100%",
  },
  deleteDialogBoxText: {
    fontFamily: "Poppins",
    fontWeight: "bold",
    fontSize: "18px",
  },
  deletePaymentCardBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: "5px",
    backgroundColor: "#eae9e9",
    padding: "5px",
    borderRadius: "6px",
    marginTop: "15px",
  },
  deletePaymentCardInnerBox: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
  },
  deletePaymentCardInnerBoxCreditText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    color: "#272525",
  },
  modalIcon: {
    height: "50px",
    width: "50px",
  },
  buttonStyle: {
    borderRadius: "5px",
    textTransform: "capitalize",
    height: "32px",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "100%",
    padding: "5px 30px",
    flex: 1,
  },
  deleteButton: {
    color: "#FF1B1B",
    background: "#FF1B1B3D",
    "&:hover": {
      color: "#FF1B1B",
      background: "#FF1B1B3D",
    },
  },
  cancelButton: {
    color: "#fff",
    background: "#4d1277",
    "&:hover": {
      color: "#fff",
      background: "#4d1277",
    },
  },
  // add payment method modal
  addPaymentMethodText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    color: "#272525",
  },
  addDetailsFields: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    color: "#272525",
    marginBottom: "5px",
  },
  paymentMethodBtnGroups: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  paymentMethodCancelButton: {
    color: "#000",
    background: "#fff",
    "&:hover": {
      color: "#000",
      background: "#fff",
    },
    border: "1px solid #000",
  },
  paymentMethodSubmitButton: {
    color: "#fff",
    background: "#4d1277",
    whiteSpace: "nowrap",
    padding: "6px 16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "&:hover": {
      color: "#fff",
      background: "#4d1277",
    },
  },

  bottomBtnBar: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: "30px",
  },

  saveBtn: {
    width: "100%",
    border: "1px solid #4D1277",
    color: "#fff",
    backgroundColor: "#4D1277",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: 400,
    fontSize: "14px",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4D1277",
      boxShadow: "none",
    },
    textTransform: "capitalize",
    boxShadow: "none",
  },
  cancelBtn: {
    width: "100%",
    border: "1px solid #272525",
    color: "#272525",
    backgroundColor: "#fff",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: 400,
    fontSize: "14px",
    "&:hover": {
      color: "#272525",
      backgroundColor: "#fff",
      boxShadow: "none",
    },
    textTransform: "capitalize",
    boxShadow: "none",
  },

  // subscriptionShownData
  subscriptionDataText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#999999",
    marginTop: "10px",
    marginBottom: "20px",
  },
  subscriptionDataCountText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#272525",
  },
  subscriptionDataPackageName: {
    textTransform: "capitalize",
    fontWeight: "700",
    fontSize: "20px",
  },
  subscriptionDataBox: {
    borderRadius: "12px",
    backgroundColor: "#EAE9E9",
    padding: "20px",
  },
  basicPlanAccessNullBox: {
    borderRadius: "12px",
    backgroundColor: "#FEE2E2",
    padding: "20px",
    marginTop: "20px",
  },
}));

export default useStyles;
